/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const AppUserListHeader = ({
  reloadUserList,
  changeStatusHandler,
  // changeAdminStatusHandler,
  updateRankHandler,
  selectedUserIds = [],
  jsonFilterQuery = [],
}) => {
  const { t } = useTranslation(); // for translations

  /* ---- bread crumb text ---- */
  const breadcrumbText = [{ title: t("App Users") }];

  return (
    <div className="bg-white pt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <Link
            onClick={reloadUserList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedUserIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedUserIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedUserIds.length === 0 ? undefined : "#addLabelModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedUserIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedUserIds.length === 0 ? undefined : "offcanvas"
                  }
                  data-bs-target={
                    selectedUserIds.length === 0
                      ? undefined
                      : "#offcanvasNewMail"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    mail
                  </span>
                  <span className="d-block">{t("Send Mail")}</span>
                </Link>
              </li>
              {/* ----- update rank section start -----  */}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedUserIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={() => {
                    if (selectedUserIds.length > 0) {
                      updateRankHandler();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    progress_activity
                  </span>
                  <span className="d-block">{t("Update Rank")}</span>
                </Link>
              </li>
              {/* ----- update rank section end -----  */}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedUserIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={() => {
                    // changeStatusHandler("1");
                    if (selectedUserIds.length > 0) {
                      changeStatusHandler("1");
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    check_circle
                  </span>
                  <span className="d-block">{t("Enable Selected")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  onClick={() => {
                    // changeStatusHandler("0");
                    if (selectedUserIds.length > 0) {
                      changeStatusHandler("0");
                    }
                  }}
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedUserIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    cancel
                  </span>
                  <span className="d-block">{t("Disable Selected")}</span>
                </Link>
              </li>

              {/* <li>
                <Link
                  to="#"
                  onClick={() => {
                    console.log("delete link");
                  }}
                  className="dropdown-item d-flex align-items-center gap-2 py-2 text-danger"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete Selected")}</span>
                </Link>
              </li> */}
            </ul>
          </div>
          <Link
            to="#"
            className={`btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm ${
              jsonFilterQuery.length > 0 ? "btn-outline-primary" : ""
            }`}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasUserFilter"
            aria-controls="offcanvasUserFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>
          <Link
            to="/admin/appuser/profile"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add New")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default AppUserListHeader;
